import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import { InputProvider } from "./shared/contexts/InputContext";
import { OutputProvider } from "./shared/contexts/OutputContext";
import Layout from "./pages/0-Layout";
import HomePage from "./pages/1-Home";
import YourDetailsPage from "./pages/2-YourDetails";
import ResultsPage from "./pages/3-Results";
import TAC from "./pages/4-TAC"

const App = () => {
  document.title = "CSNI Partial Retirement Remedy Benefits Illustrator";
  return (
    <InputProvider>
      <OutputProvider>
        <Router>
          <Layout>
            <Routes>
            <Route path="/" exact element={<HomePage />} />
              <Route path="/yourdetails" element={<YourDetailsPage />} />
              <Route path="/results" element={<ResultsPage />} />
              <Route path="/T&Cs" element={<TAC />} />
            </Routes>
          </Layout>
        </Router>
      </OutputProvider>
    </InputProvider>
  );
};

export default App;
